import { createSlice } from "@reduxjs/toolkit";
import helperFunctions from "../../utils/helper";

const initialState = {
  data: [],
  ownership: [],
  selectedOwnership: {},
  loading: false,
  error: null,
};

const villageDetails = createSlice({
  name: "villageDetails",
  initialState,
  reducers: {
    fetchVillageDetailsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchVillageDetailsSuccess(state, action) {
      console.log("fetchDataSuccess villageDetails success");
      state.loading = false;

      const tempData = action.payload;
      console.log("payloadData ", tempData);
      var diffOwnership = helperFunctions.getDistinctValues(
        tempData,
        "gov_status"
      );
      state.data = tempData;
      state.ownership = diffOwnership;
      state.selectedOwnership = helperFunctions.selectAllValues(diffOwnership);
      console.log("diff ownership are ", state.ownership);
      console.log("selected ownership are ", state.selectedOwnership);
      console.log("Village details are", state.data);
      console.log("fetchDataSuccess villageDetails success data");
    },
    selectOwnershipType(state, action) {
      state.loading = false;
      state.selectedOwnership = {
        ...state.selectedOwnership,
        ...action.payload,
      };
    },
    fetchVillageDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchVillageDetailsStart,
  fetchVillageDetailsSuccess,
  selectOwnershipType,
  fetchVillageDetailsFailure,
} = villageDetails.actions;
export default villageDetails.reducer;
